import React, { useState, useEffect } from 'react';
import { FaWarehouse, FaShippingFast, FaUsers } from 'react-icons/fa';

const AnimatedCounter = ({ end, duration = 2000, start = 0 }) => {
  const [count, setCount] = useState(start);

  useEffect(() => {
    let startTime;
    let animationFrame;

    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = timestamp - startTime;
      const percentage = Math.min(progress / duration, 1);
      
      // Easing function for smooth animation
      const easeOutQuad = percentage => 1 - (1 - percentage) * (1 - percentage);
      const currentCount = Math.floor(start + (end - start) * easeOutQuad(percentage));
      
      setCount(currentCount);

      if (percentage < 1) {
        animationFrame = requestAnimationFrame(animate);
      }
    };

    animationFrame = requestAnimationFrame(animate);

    return () => {
      if (animationFrame) {
        cancelAnimationFrame(animationFrame);
      }
    };
  }, [end, duration, start]);

  return <span>{count.toLocaleString()}</span>;
};

const StatisticsBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="bg-green-700 text-white p-6 md:p-8 rounded-lg">
      <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-12">
        {/* Metric Tons Manufactured */}
        <div className="text-center w-full md:w-auto">
          <div className="flex justify-center items-center mb-2">
            <FaWarehouse className="text-4xl md:text-5xl text-white" />
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold">
            {isVisible && <AnimatedCounter end={5000} start={1000} />}+
          </h2>
          <p className="text-xs md:text-sm mt-2 uppercase tracking-wider">
            Metric Tons Manufactured
          </p>
        </div>
        
        <div className="hidden md:block h-12 w-px bg-white/70"></div>

        {/* Containers Exported */}
        <div className="text-center w-full md:w-auto">
          <div className="flex justify-center items-center mb-2">
            <FaShippingFast className="text-4xl md:text-5xl text-white" />
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold">
            {isVisible && <AnimatedCounter end={250} start={50} />}+
          </h2>
          <p className="text-xs md:text-sm mt-2 uppercase tracking-wider">
            Containers Exported
          </p>
        </div>
        
        <div className="hidden md:block h-12 w-px bg-white/70"></div>

        {/* Employees */}
        <div className="text-center w-full md:w-auto">
          <div className="flex justify-center items-center mb-2">
            <FaUsers className="text-4xl md:text-5xl text-white" />
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold">
            {isVisible && <AnimatedCounter end={30} start={5} />}+
          </h2>
          <p className="text-xs md:text-sm mt-2 uppercase tracking-wider">
            Employees
          </p>
        </div>
      </div>
    </div>
  );
};

export default StatisticsBanner;
